import SubmitProofTimerSvg from '@assets/images/svg/submit-proof-timer.svg';
import React from 'react';
import { View } from 'react-native';

export interface SubmitProofTimerIconProps {
  size?: number;
  color?: string;
}

/** Figma Submit Your Proof timer — stroke #FBC02D */
export function SubmitProofTimerIcon({
  size = 24,
  color = '#FBC02D',
}: Readonly<SubmitProofTimerIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <SubmitProofTimerSvg width={size} height={size} color={color} />
    </View>
  );
}

export default SubmitProofTimerIcon;
